export const addTimestampToFileName = (fileName: string): string => {
  const name = fileName.substr(0, fileName.lastIndexOf('.'))
  const extension = fileName.substr(fileName.lastIndexOf('.') + 1)
  return `${name}${+new Date()}.${extension}`
}
